module.exports = __webpack_public_path__ + "static/img/l2.d1711ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/l2.jpg
// module id = 635
// module chunks = 0